<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Download">
  <!-- pdf -->
  <div class="card border margin-item">
    <div class="w-100 worksheet-image-height position-relative rounded">
      <img
        class="w-100 worksheet-image-height object-cover rounded-img"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <div class="font-size-14 text-black p-2 justify-content-start position-relative text-start mb-3 w-100">
      {{ worksheetItem.Description }}
    </div>
    <div
      target="_blank"
      (click)="getDownload(worksheetId, worksheetItem.Id)"
      class="btn btn-primary bg-button text-white border-0 mt-4 p-2 m-3 fw-bold font-size-14"
    >
      {{ 'worksheet.download' | translate }}
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Gallery">
  <!-- image -->
  <div class="my-3 rounded cursor-pointer" (click)="openGalleryImage(galleryImage)">
    <img
      [src]="worksheetItem.Image | contentImage : '1' : 'marketplace'"
      [alt]="worksheetItem.Title"
      [useDefault]="true"
      draggable="false"
      class="worksheet-image rounded"
    />
    <div class="mt-2 font-size-14">{{ worksheetItem.Description }}</div>
  </div>
  <ng-template #galleryImage let-modal>
    <div class="modal-header justify-content-center border-0">
      <span class="text-white cursor-pointer material-icons material-mobile-nav" (click)="modal.dismiss()">cancel</span>
    </div>
    <div class="modal-body">
      <img
        *ngIf="worksheetItem.Image"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        class="modal-image"
        [alt]="worksheetItem.Title"
        [@zoomAnimation]
      />
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.ProviderVideo">
  <!-- video -->
  <div class="border-0 player-container">
    <div [ngSwitch]="worksheetItem.ProviderId" class="h-100">
      <ng-container *ngSwitchCase="providerName.Facebook">
        <fgb-facebook-player [streamKey]="worksheetItem.ProviderKey"></fgb-facebook-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.YouTube">
        <fgb-youtube-player [streamKey]="worksheetItem.ProviderKey"></fgb-youtube-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.StreamingVideoProvider">
        <fgb-svp-player [streamKey]="worksheetItem.ProviderKey"></fgb-svp-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Twitch">
        <fgb-twitch-player [streamKey]="worksheetItem.ProviderKey"></fgb-twitch-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Viemo">
        <fgb-vimeo-player [streamKey]="worksheetItem.ProviderKey"></fgb-vimeo-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Boxcast">
        <fgb-boxcast-player [streamKey]="worksheetItem.ProviderKey"></fgb-boxcast-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Streamable">
        <fgb-streamable-player [streamKey]="worksheetItem.ProviderKey"></fgb-streamable-player>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Link">
  <!-- link -->
  <div class="card border-0 shadow my-3 rounded p-2">
    <div>
      <img
        style="height: 55px; max-width: 200px"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />

      <div class="my-2 fw-bold">{{ worksheetItem.Description }}</div>

      <a
        target="_blank"
        [href]="worksheetItem.LinkUrl"
        class="btn btn-primary bg-primary text-white border-0 fw-bold font-size-14"
        >{{ 'worksheet.download' | translate | uppercase }}</a
      >
    </div>
  </div>
</ng-container>
